import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useNavigate } from "react-router-dom";

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const navItems = [
    { label: "Home", path: "home" },
    { label: "Products For Consumer", path: "Customers" },
    { label: "Products For Farmer", path: "Consumers" },
    { label: "Aquaculture Division", path: "aquaculture-division" },
    { label: "Contact", path: "contact" },
  ];

  const handleNavigation = (path) => {
    navigate(`/${path}`);
    setMobileOpen(false);
  };

  return (
    <AppBar position="sticky" sx={{ boxShadow: 1, background: "white", paddingX:"40px" }}>
      <Toolbar>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          <Link to="/" style={{ textDecoration: "none" }}>
            <img src="/assets/logo2.png" alt="Logo" height={100} width={100} />
          </Link>
        </Typography>
        ;{/* Desktop Navigation */}
        <Box sx={{ display: { xs: "none", md: "block" } }}>
          <ul
            style={{
              listStyle: "none",
              display: "flex",
              padding: 0,
              margin: 0,
            }}
          >
            {navItems.map((item) => (
              <li
                key={item.path}
                style={{
                  margin: "0 10px",
                  cursor: "pointer",
                  color: "black",
                  textTransform: "uppercase",
                }}
                onClick={() => handleNavigation(item.path)}
              >
                <Typography>{item.label}</Typography>
              </li>
            ))}
          </ul>
        </Box>
        {/* Mobile Menu Button */}
        <IconButton
          style={{ color: "black" }}
          edge="start"
          aria-label="menu"
          sx={{ display: { md: "none" } }}
          onClick={handleDrawerToggle}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>

      {/* Mobile Drawer */}
      <Drawer
        anchor="left"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        sx={{ ".MuiDrawer-paper": { width: "100vw", height: "100vh" } }}
      >
        <ul
          style={{
            listStyle: "none",
            padding: "10px",
            textAlign: "center",
            width: "100%",
          }}
        >
          {navItems.map((item) => (
            <li
              key={item.path}
              style={{
                padding: "20px 0",
                cursor: "pointer",
                fontSize: "1.5rem",
                textTransform: "uppercase",
              }}
              onClick={() => handleNavigation(item.path)}
            >
              <Typography>{item.label}</Typography>
            </li>
          ))}
        </ul>
      </Drawer>
    </AppBar>
  );
};

export default Navbar;
